// require("dotenv").config();

export async function imageGen(theme) {
  const prexelApiKey = process.env.PREXEL;

  const response = await fetch(
    `https://api.pexels.com/v1/search?query=${theme}&per_page=1`,
    {
      headers: {
        Authorization: "OFKdZ3OS9zHb9SV9dfEOjjXbHW3copEZJ0TQqQK0h819ISovRSorakdu" //prexelApiKey
      }
    }
  );

  const data = await response.json();

  const imageUrl = data?.photos?.[0]?.src?.large;

  return imageUrl;
}
